// function Footer() {
//   return (
//     <footer className="bg-gray-800 text-white p-4 text-center">
//       © 2026 Satish Portfolio
//     </footer>
//   );
// }
// export default Footer;
import { useNavigate } from "react-router-dom";

const SPECS = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='28' viewBox='0 0 48 28'%3E%3Crect x='1' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Crect x='29' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Cpath d='M19 13 L29 13' stroke='%231a1a1a' stroke-width='2.5' stroke-linecap='round'/%3E%3Cpath d='M1 13 L0 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M47 13 L48 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E`;

const css = `
  @keyframes ft-marquee {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
  }
  .ft-ticker-inner {
    display: inline-flex; white-space: nowrap;
    animation: ft-marquee 22s linear infinite;
  }
  .ft-ticker-inner:hover { animation-play-state: paused; }

  /* nav links — mirrors navbar style */
  .ft-nav-link {
    font-family: 'DM Sans', sans-serif;
    font-size: 11px; font-weight: 700;
    letter-spacing: .1em; text-transform: uppercase;
    color: #aaa; background: none; border: none;
    padding: 0; cursor: url("${SPECS}") 24 14, pointer;
    text-decoration: none;
    transition: color .15s;
    display: block;
    text-align: right;
  }
  .ft-nav-link:hover, .ft-nav-link.active { color: #111; text-decoration: underline; text-underline-offset: 3px; }

  /* icon nav items */
  .ft-icon-item {
    display: flex; flex-direction: column; align-items: center; gap: 4px;
    cursor: url("${SPECS}") 24 14, pointer;
    color: #999;
    background: none; border: none;
    text-decoration: none;
    transition: color .15s;
  }
  .ft-icon-item:hover { color: #111; }
  .ft-icon-label {
    font-family: 'DM Sans', sans-serif;
    font-size: 9px; font-weight: 700;
    letter-spacing: .12em; text-transform: uppercase;
  }

  /* email pill */
  .ft-email-pill {
    display: inline-flex; align-items: center; gap: 8px;
    border: 1px solid #ddd;
    border-radius: 999px;
    padding: 8px 16px;
    font-family: 'DM Sans', sans-serif;
    font-size: 12.5px; font-weight: 500;
    color: #333; text-decoration: none;
    background: #fff;
    transition: border-color .15s, color .15s;
    white-space: nowrap;
  }
  .ft-email-pill:hover { border-color: #111; color: #111; }

  /* back to top */
  .ft-top-btn {
    width: 40px; height: 40px;
    border-radius: 50%;
    border: 1px solid #ddd;
    background: #fff;
    display: flex; align-items: center; justify-content: center;
    cursor: url("${SPECS}") 24 14, pointer;
    color: #666;
    transition: border-color .15s, color .15s, transform .15s;
  }
  .ft-top-btn:hover { border-color: #111; color: #111; transform: translateY(-3px); }

  @media(max-width:640px){
    .ft-body { flex-direction: column !important; gap: 32px !important; }
    .ft-right { align-items: flex-start !important; }
    .ft-name { font-size: clamp(44px,14vw,80px) !important; line-height: .92 !important; }
  }
`;

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer style={{
      background: "#fafafa",
      backgroundImage: "linear-gradient(rgba(0,0,0,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.045) 1px,transparent 1px)",
      backgroundSize: "32px 32px",
      borderTop: "1px solid #e8e8e8",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <style>{css}</style>

      {/* ── TICKER ── */}
      <div style={{ overflow: "hidden", borderBottom: "1px solid #ebebeb", padding: "9px 0" }}>
        <div className="ft-ticker-inner">
          {[...Array(6)].map((_, i) => (
            <span key={i} style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".2em", textTransform: "uppercase", color: "#ccc", paddingRight: 48 }}>
              ✦ DESIGNED IN FIGMA · BUILT WITH REACT · SATISH DANDABATHULA · UI/UX DESIGNER · ANDHRA PRADESH, INDIA ·&nbsp;
            </span>
          ))}
        </div>
      </div>

      {/* ── BODY — mirrors navbar padding exactly ── */}
      <div className="ft-body" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "40px 32px 36px" }}>

        {/* LEFT — mirrors navbar left (name + role + location) */}
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <p style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".16em", textTransform: "uppercase", color: "#bbb", marginBottom: 10 }}>
            A PORTFOLIO SHOWCASE BY
          </p>

          {/* BIG name — full width display */}
          <h2 className="ft-name" style={{
            fontSize: "clamp(56px,9vw,120px)",
            fontWeight: 800,
            color: "#111",
            letterSpacing: "-0.03em",
            lineHeight: .92,
            marginBottom: 20,
          }}>
            SATISH<br />DANDABATHULA
          </h2>

          {/* <p style={{ fontSize: 11, fontWeight: 500, color: "#aaa", letterSpacing: ".06em", marginBottom: 2 }}>
            UI/UX DESIGNER · B2B SAAS
          </p>
          <p style={{ fontSize: 11, fontWeight: 500, color: "#bbb", letterSpacing: ".06em", marginBottom: 24 }}>
            ANDHRA PRADESH, INDIA
          </p> */}

          <p style={{ fontSize: 12, color: "#bbb", lineHeight: 1.6 }}>
            Made with <span style={{ color: "#ef4444" }}>♥</span> <br />
            from the Land of Victory, Vijayawada.
          </p>
          {/* <p style={{ fontSize: 11, color: "#ccc", marginTop: 8 }}>
            © 2025 Satish Dandabathula · All Rights Reserved
          </p> */}
        </div>

        {/* RIGHT — mirrors navbar right (nav links stacked + contact) */}
        <div className="ft-right" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "space-between", height: "100%", gap: 24 }}>

          {/* Nav links stacked — same as navbar */}
          {/* <nav style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "flex-end" }}>
            {[
              { label: "WORK",     action: () => navigate("/") },
              { label: "ABOUT",    action: () => navigate("/about") },
              { label: "RESUME",   action: () => {} },
              { label: "CONTACT",  action: () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }) },
            ].map(l => (
              <button key={l.label} className="ft-nav-link" onClick={l.action}>{l.label}</button>
            ))}
          </nav> */}

          {/* Back to top + icon nav + email */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 16 }}>

            {/* back to top */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5 }}>
              <button className="ft-top-btn" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 19V5M5 12l7-7 7 7"/>
                </svg>
              </button>
              <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "#bbb" }}>BACK TO TOP</span>
            </div>

            {/* icon nav pill — WORK · ABOUT · LINKEDIN · RESUME */}
            <div style={{ display: "flex", alignItems: "flex-end", gap: 20, padding: "12px 20px", background: "#fff", border: "1px solid #e8e8e8", borderRadius: 999 }}>
              {[
                { label: "WORK", action: () => navigate("/"),
                  icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg> },
                { label: "ABOUT", action: () => navigate("/about"),
                  icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.582-7 8-7s8 3 8 7"/></svg> },
                { label: "LINKEDIN", action: () => window.open("https://www.linkedin.com/in/satish-dandabathula-00b35115b/", "_blank"),
                  icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg> },
                { label: "RESUME", action: () => {},
                  icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> },
              ].map(item => (
                <button key={item.label} className="ft-icon-item" onClick={item.action}>
                  {item.icon}
                  <span className="ft-icon-label">{item.label}</span>
                </button>
              ))}
            </div>

            {/* contact */}
            <div style={{ textAlign: "right" }}>
              <p style={{ fontSize: 11, color: "#bbb", marginBottom: 8 }}>You can connect me on my personal mail</p>
              <a href="mailto:satishdandabathula@gmail.com" className="ft-email-pill">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
                satishkumar.dandabathula@gmail.com
              </a>
            </div>

          </div>
        </div>

      </div>

      {/* ── BOTTOM STRIP ── */}
      {/* <div style={{ borderTop: "1px solid #ebebeb", padding: "10px 32px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 6 }}>
        <p style={{ fontSize: 10, color: "#ccc", letterSpacing: ".04em" }}>
          © 2025 Satish Dandabathula · All Rights Reserved
        </p>
        <p style={{ fontSize: 10, color: "#ccc", letterSpacing: ".04em" }}>
          Designed in Figma · Developed in React · No templates used
        </p>
      </div> */}

    </footer>
  );
}